import { buildCareStateGroupedListRows } from '@/entities/care-state-domain';
import type { CareStateDomainDb } from '@/entities/care-state-domain';

export function findNextOpenRequestInTreeOrder(
  careState: CareStateDomainDb,
  currentRequestId: string
): string | null {
  const requestById = new Map(careState.requests.map((request) => [request.id, request] as const));

  const orderedRequestIds = buildCareStateGroupedListRows(careState)
    .map((row) => {
      if (!row.id.startsWith('request:')) {
        return null;
      }
      return row.id.slice('request:'.length);
    })
    .filter((requestId): requestId is string => requestId !== null);

  const currentIndex = orderedRequestIds.indexOf(currentRequestId);
  const isOpen = (requestId: string): boolean => {
    return requestId !== currentRequestId && requestById.get(requestId)?.status === 'Open';
  };

  if (currentIndex >= 0) {
    for (let i = currentIndex + 1; i < orderedRequestIds.length; i += 1) {
      const candidateId = orderedRequestIds[i];
      if (candidateId !== undefined && isOpen(candidateId)) {
        return candidateId;
      }
    }
  }

  for (let i = 0; i < orderedRequestIds.length; i += 1) {
    const candidateId = orderedRequestIds[i];
    if (candidateId !== undefined && isOpen(candidateId)) {
      return candidateId;
    }
  }

  return null;
}
